/* FD PDP fixes — Aug 2026 (v5.3)
   Change vs v5.2: no DOM wipe after HEALTHY destroys (PhotoSwipe resets its
   own template; the extra sweep could race the next open). Wipe now runs
   ONLY on failure paths: close stalled, close/destroy threw, stale template
   found before a new open. Kill switch: ?fd_fix_off=1 or localStorage.fdFixOff='1'. */
(function(){
  'use strict';
  if(window.__fdPdpFixLoaded){return;}
  window.__fdPdpFixLoaded=true;
  function log(){ try{ var a=['[FD-fix]'].concat([].slice.call(arguments)); console.log.apply(console,a); }catch(e){} }
  try{
    if(window.location.search.indexOf('fd_fix_off')>-1||window.localStorage.getItem('fdFixOff')==='1'){
      log('DISABLED via kill switch (fd_fix_off)');
      return;
    }
  }catch(e){}
  log('script loaded (v5.3)');

  function releaseFlickity(){
    if(!window.Flickity||!window.Flickity.data)return;
    var els=document.querySelectorAll('.flickity-enabled');
    for(var i=0;i<els.length;i++){
      var inst;
      try{ inst=window.Flickity.data(els[i]); }catch(e){ continue; }
      if(!inst)continue;
      try{
        if(inst.isPointerDown||inst.isDragging){
          log('releasing stuck Flickity drag');
          try{ if(typeof inst.pointerCancel==='function'){ inst.pointerCancel(inst.pointerDownEvent||{}); } }catch(e){}
          inst.isPointerDown=false;
          inst.isDragging=false;
          try{ if(typeof inst._unbindPostStartEvents==='function'){ inst._unbindPostStartEvents(); } }catch(e){}
          try{ if(inst.element){ inst.element.classList.remove('is-dragging','is-pointer-down'); } }catch(e){}
          try{ if(typeof inst.select==='function'){ inst.select(inst.selectedIndex||0,!1,!0); } }catch(e){}
        }
      }catch(e){}
    }
  }
  var releaseTimer=null;
  function scheduleRelease(){ clearTimeout(releaseTimer); releaseTimer=setTimeout(releaseFlickity,600); }
  document.addEventListener('touchend',scheduleRelease,true);
  document.addEventListener('touchcancel',scheduleRelease,true);
  document.addEventListener('pointerup',scheduleRelease,true);

  function domWipe(reason){
    log('domWipe:',reason);
    var els=document.querySelectorAll('.pswp');
    for(var i=0;i<els.length;i++){
      var el=els[i];
      el.className='pswp';
      el.setAttribute('aria-hidden','true');
      el.removeAttribute('style');
      var kids=el.querySelectorAll('.pswp__bg,.pswp__container,.pswp__zoom-wrap,.pswp__item,.pswp__img');
      for(var j=0;j<kids.length;j++) kids[j].removeAttribute('style');
      var ui=el.querySelector('.pswp__ui'); if(ui) ui.className='pswp__ui pswp__ui--hidden';
    }
    document.documentElement.classList.remove('lock-scroll','modal-open');
    if(document.body) document.body.classList.remove('lock-scroll');
    releaseFlickity();
  }
  function killInstance(reason){
    var g=window.__fdGallery;
    if(g&&!g.__fdDead){
      g.__fdDead=true;
      log('destroying previous gallery:',reason);
      try{ g.destroy(); }catch(e){ log('previous destroy threw — wiping DOM'); domWipe('destroy-threw'); }
    }
    window.__fdGallery=null;
  }

  window.FDGALLERY_DEBUG=function(){
    var el=document.querySelector('.pswp');
    var cs=el?window.getComputedStyle(el):null;
    var out={
      pswpClass: el?el.className:null,
      display: cs?cs.display:null,
      opacity: cs?cs.opacity:null,
      zIndex: cs?cs.zIndex:null,
      imgCount: document.querySelectorAll('.pswp__img').length,
      ariaHidden: el?el.getAttribute('aria-hidden'):null,
      htmlClass: document.documentElement.className,
      hasInstance: !!window.__fdGallery,
      instanceDead: window.__fdGallery?!!window.__fdGallery.__fdDead:null,
      flickity: (window.Flickity&&window.Flickity.data)?[].map.call(document.querySelectorAll('.flickity-enabled'),function(e){var i=window.Flickity.data(e);return i?{down:!!i.isPointerDown,drag:!!i.isDragging}:null}):'n/a'
    };
    log('DEBUG',JSON.stringify(out));
    return out;
  };

  function hook(){
    if(!(window.theme&&window.theme.Photoswipe&&window.theme.Photoswipe.prototype))return false;
    var proto=window.theme.Photoswipe.prototype;
    if(proto.__fdFixed)return true;
    var orig=proto.initGallery;
    if(!orig)return false;
    proto.__fdFixed=true;
    proto.initGallery=function(items,index){
      killInstance('opening new gallery');
      var stale=document.querySelector('.pswp.pswp--open');
      if(stale){ domWipe('stale open template before new open'); }
      log('opening gallery: items='+(items?items.length:0)+' index='+index);
      var out;
      try{ out=orig.call(this,items,index); }
      catch(e){ log('initGallery threw:',e&&e.message); domWipe('init-threw'); throw e; }
      releaseFlickity();
      try{
        var g=this.gallery;
        window.__fdGallery=g;
        if(g){
          ['close','destroy'].forEach(function(fn){
            var o=g[fn];
            if(typeof o!=='function')return;
            g[fn]=function(){
              try{ return o.apply(g,arguments); }
              catch(e){ log(fn+' threw:',e&&e.message); g.__fdDead=true; domWipe(fn+'-threw'); }
            };
          });
          if(g.listen){
            g.listen('close',function(){
              log('close event');
              setTimeout(function(){
                if(!g.__fdDead&&document.querySelector('.pswp.pswp--open')){
                  log('close did not complete — forcing');
                  g.__fdDead=true;
                  domWipe('close-stalled');
                }
              },900);
            });
            g.listen('destroy',function(){
              log('destroy event (healthy — no wipe)');
              g.__fdDead=true;
              if(window.__fdGallery===g)window.__fdGallery=null;
            });
          }
        }
      }catch(e){ log('hook wiring error:',e&&e.message); }
      return out;
    };
    log('Photoswipe hook installed');
    return true;
  }
  if(!hook()){
    document.addEventListener('DOMContentLoaded',hook);
    window.addEventListener('load',hook);
  }

  function closeTap(e){
    var t=e.target;
    if(t&&t.closest&&t.closest('.pswp__button--close')){
      setTimeout(function(){
        var g=window.__fdGallery;
        if(document.querySelector('.pswp.pswp--open')&&(!g||!g.__fdDead)){
          log('close button did not close — forcing');
          killInstance('close-button rescue');
          domWipe('close-button rescue');
        }
      },1200);
    }
  }
  document.addEventListener('click',closeTap,true);
  document.addEventListener('touchend',closeTap,true);
})();
